import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';  // Tailwind v3 포함
import './i18n';
import App from './App';
import reportWebVitals from './reportWebVitals';

// React Grab - 개발 모드에서만 활성화 (AI 코딩 어시스턴트용)
if (process.env.NODE_ENV === 'development') {
  import('react-grab').catch(() => {});
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
